import { makeSelectLocale } from 'containers/LanguageProvider/selectors';
import { useSelector } from 'react-redux';

function useLocale() {
  const locale = useSelector(makeSelectLocale);
  return locale;
}

export default useLocale;
